import _ from 'lodash';
import Api from '../../services/api';
import RequestStatus from '../../constant/request';
import Emitter from '../../services/emitter';
import Storage from '../../services/api/store';
import CONSTANT from '../../constant';
import { requestDispatch } from '../../util';
import { isInternational } from '../../util/env';

const CHANGE_MODE = 'CHANGE_MODE';
const CHANGE_LOGIN_STATE = 'CHANGE_LOGIN_STATE';
const GET_USER_STATE = 'GET_USER_STATE';
const USER_LOGIN = 'USER_LOGIN';
const USER_LOGOUT = 'USER_LOGOUT';
const USER_REGISTER = 'USER_REGISTER';
const USER_FINDPWD = 'USER_FINDPWD';
const GET_VALID_CODE = 'GET_VALID_CODE';
const GET_URL_TOKEN = 'GET_URL_TOKEN';
const SAVE_EMAILNUM = 'SAVE_EMAILNUM';
const CHECK_EMAILNUM = 'CHECK_EMAILNUM';
const USER_UPDATEPWD = 'USER_UPDATEPWD';
const CHECK_CODE_REQUEST = 'CHECK_CODE_REQUEST';
const CHECK_CODE = 'CHECK_CODE';
const CHECK_OLDPWD_REQUEST = 'CHECK_OLDPWD_REQUEST';
const CHECK_OLDPWD = 'CHECK_OLDPWD';
const UPDATEPWD_REQUEST = 'UPDATEPWD_REQUEST';
const UPDATEPWD = 'UPDATEPWD';
const SET_OVERAGE = 'SET_OVERAGE';

/**
 * A request dispatch
 *
 * @param {any} actionType
 * @param {any} requestApi
 * @param {any} formData
 * @param {any} successCb
 * @param {any} failCb
 * @returns dispatch execute function
 */
const _requestDispatch = (actionType, requestApi, formData, successCb, failCb) => {
    return requestDispatch('UserService', actionType, requestApi, formData, successCb, failCb);
};

const _resetState = (state, action, key) => {
    // 处理 无网络情况下退出登录
    if ((action.status === RequestStatus.PENDING || (action.data && action.data.code === 99999))) {
        return Object.assign({}, state, {
            ...state,
            [key]: action.status,
            code: action.data && action.data.code
        });
    }

    const isLogin = _saveUserToLocal(action);
    const _state = {
        [key]: action.status,
        data: isLogin ? action.data.user : action.data,
        token: isLogin ? action.data.token : null,
        isLogin: isLogin
    };
    return Object.assign({}, state, _state);
};

const _saveUserToLocal = (action) => {
    if (action.status === RequestStatus.DONE) {
        const data = action.data;
        const is_check = action.type === GET_USER_STATE;
        if (is_check) {
            data.token = Api.UserService.getUserToken();
        }
        if (_.has(data, 'token') && _.has(data, 'user')) {
            Api.UserService.saveUserInfoToLocal(data);
            Emitter.emit('Login');
            return true;
        }
    }
    return false;
};

const defaultState = {
    // 国际化登陆状态
    isInternational: isInternational(),
    // 用户是否已满16岁
    overAge: false,
    // 用户输入的合法账号
    emailNum: '',
    // 用户输入的正确验证码
    validCode: '',
    // 用户输入的旧密码
    oldpassword: '',
    // 登陆状态
    isLogin: false,
    // 用户数据
    data: {
        account: '',
        email: '',
        userName: '',
        uid: '',
        headpic: '',
        isBindEmail: false,
        isBindQQ: false,
        isBindWechat: false,
        isBindGoogle: false,
        isBindFacebook: false
    }
};

class User {

    constructor() {
    }

    reducer(state = defaultState, action) {
        switch (action.type) {
            case GET_URL_TOKEN:
                return Object.assign({}, state, {
                    urlTokenRequest: action.status
                });
            case CHANGE_MODE:
                return { ...state, isInternational: action.payload.isInternational };
            case CHANGE_LOGIN_STATE:
                return { ...state, isLogin: action.payload.isLogin };
            case SET_OVERAGE:
                return { ...state, overAge: action.payload.overAge };
            case GET_USER_STATE:
                return _resetState(state, action, 'checkAccountRequest');
            case USER_LOGOUT:
                return _resetState(state, action, 'logoutRequest');
            case SAVE_EMAILNUM:
                return { ...state, checkEmailNumRequest: RequestStatus.PENDING, emailNum: action.payload.emailNum };
            case CHECK_EMAILNUM:
                return { ...state, checkEmailNumRequest: action.payload.checkEmailNumRequest };
            case CHECK_CODE_REQUEST:
                return { ...state, checkCodeRequest: RequestStatus.PENDING };
            case CHECK_CODE:
                return { ...state, checkCodeRequest: action.payload.checkCodeRequest, validCode: action.payload.validCode };
            case CHECK_OLDPWD_REQUEST:
                return { ...state, checkOldPwdRequest: RequestStatus.PENDING };
            case CHECK_OLDPWD:
                return { ...state, checkOldPwdRequest: action.payload.checkOldPwdRequest, oldpassword: action.payload.oldpassword };
            case UPDATEPWD_REQUEST:
                return { ...state, updatepwdRequest: RequestStatus.PENDING };
            case UPDATEPWD:
                return { ...state, updatepwdRequest: action.payload.updatepwdRequest };
            case USER_LOGIN:
                return _resetState(state, action, 'loginRequest');
            case USER_REGISTER:
                return _resetState(state, action, 'registerRequest');
            case USER_FINDPWD:
                return _resetState(state, action, 'findpwdRequest');
            case USER_UPDATEPWD:
                return _resetState(state, action, 'updatepwdRequest');
            case GET_VALID_CODE:
                return _resetState(state, action, 'codeRequest');
            default:
                return state;
        }
    }

    changeMode(data) {
        return (dispatch) => {
            Storage.set(CONSTANT.INTERNATIONAL_VERSION, data);
            dispatch({ type: CHANGE_MODE, payload: { isInternational: data } });
        };
    }

    checkUserTokenExist() {
        let token = Api.UserService.getUserToken();
        return token;
    }

    getUserState(successCb, failCb) {
        if (!this.checkUserTokenExist()) {
            return {
                type: GET_USER_STATE,
                data: {
                    status: RequestStatus.DONE
                }
            };
        }
        return _requestDispatch.bind(this)(GET_USER_STATE, 'get_account', null, successCb, failCb);
    }

    checkEmailNum(emailNum, successCb, failCb) {
        return (dispatch) => {
            dispatch({ type: SAVE_EMAILNUM, payload: { emailNum } });
            return Api.UserService.check_account({ account: emailNum }).then(res => {
                dispatch({ type: CHECK_EMAILNUM, payload: { checkEmailNumRequest: RequestStatus.DONE } });
                _.isFunction(successCb) && successCb(res);
            }, data => {
                dispatch({ type: CHECK_EMAILNUM, payload: { checkEmailNumRequest: RequestStatus.FAILED } });
                _.isFunction(failCb) && failCb(data);
            });
        };
    }

    login(formData, successCb, failCb) {
        const data = {
            account: formData.account,
            password: formData.password
        };
        return _requestDispatch.bind(this)(USER_LOGIN, 'login', data, successCb, failCb);
    }

    setOverAge(overAge) {
        return (dispatch) => {
            dispatch({ type: SET_OVERAGE, payload: { overAge } });
        };
    }

    register(formData, successCb, failCb) {
        const data = {
            email: formData.email,
            password: formData.password
        };
        return _requestDispatch.bind(this)(USER_REGISTER, 'register', data, successCb, failCb);
    }

    saveValidCode(formData, successCb, failCb) {
        const data = {
            email: formData.email,
            findPwdCode: formData.validCode
        };
        return (dispatch) => {
            dispatch({ type: CHECK_CODE_REQUEST });
            return Api.UserService.check_validCode(data).then(res => {
                dispatch({ type: CHECK_CODE, payload: { checkCodeRequest: RequestStatus.DONE, validCode: formData.validCode } });
                _.isFunction(successCb) && successCb(res);
            }, data => {
                dispatch({ type: CHECK_CODE, payload: { checkCodeRequest: RequestStatus.FAILED } });
                _.isFunction(failCb) && failCb(data);
            });
        };
    }

    findpwd(formData, successCb, failCb) {
        const data = {
            email: formData.email,
            password: formData.password,
            findpwdcode: formData.findpwdcode
        };
        return _requestDispatch.bind(this)(USER_UPDATEPWD, 'resetpwd', data, successCb, failCb);
    }

    saveOldPwd(formData, successCb, failCb) {
        const data = {
            account: formData.email,
            password: formData.oldpassword
        };
        return (dispatch) => {
            dispatch({ type: CHECK_OLDPWD_REQUEST });
            return Api.UserService.check_oldPwd(data).then(res => {
                dispatch({ type: CHECK_OLDPWD, payload: { checkOldPwdRequest: RequestStatus.DONE, oldpassword: formData.oldpassword } });
                _.isFunction(successCb) && successCb(res);
            }, data => {
                dispatch({ type: CHECK_OLDPWD, payload: { checkOldPwdRequest: RequestStatus.FAILED, data } });
                _.isFunction(failCb) && failCb(data);
            });
        };
    }

    updatePwd(formData, successCb, failCb) {
        const data = {
            account: formData.email,
            oldpassword: formData.oldpassword,
            newpassword: formData.newpassword
        };
        return (dispatch) => {
            dispatch({ type: UPDATEPWD_REQUEST });
            return Api.UserService.updatepwd(data).then(res => {
                dispatch({ type: UPDATEPWD, payload: { updatepwdRequest: RequestStatus.DONE, oldpassword: '' } });
                _.isFunction(successCb) && successCb(res);
            }, data => {
                dispatch({ type: UPDATEPWD, payload: { updatepwdRequest: RequestStatus.FAILED } });
                _.isFunction(failCb) && failCb(data);
            });
        };
    }

    getValidCode(formData, successCb, failCb) {
        const data = { email: formData };
        return () => {
            return Api.UserService.get_findpwd_code(data).then(res => {
                _.isFunction(successCb) && successCb(res);
            }, data => {
                _.isFunction(failCb) && failCb(data);
            });
        };
    }

    urlToken(successCb, failCb) {
        return _requestDispatch.bind(this)(GET_URL_TOKEN, 'geturltoken', null, successCb, failCb);
    }

    deleteAccount(password, successCb, failCb) {
        return () => {
            return Api.UserService.delete_account({ password }).then(res => {
                _.isFunction(successCb) && successCb(res);
            }, data => {
                _.isFunction(failCb) && failCb(data);
            });
        };
    }

    logout(successCb, failCb) {
        return _requestDispatch.bind(this)(USER_LOGOUT, 'logout', null, () => {
            Api.UserService.removeUserinfoToLocal();
            Emitter.emit('Logout');
            Emitter.emit('ClearProjects');
            _.isFunction(successCb) && successCb();
        }, failCb);
    }

    setLoginState(state) {
        return {
            type: CHANGE_LOGIN_STATE,
            payload: {
                isLogin: state
            }
        };
    }
}

export default new User();